import { fadeInScaleUpTransition as e } from "../../../_styles/transitions/fade-in-scale-up.cssr.js";
import { c as n, cB as o } from "../../../_utils/cssr/index.js";
const a = n([o("select", `
 z-index: auto;
 outline: none;
 width: 100%;
 position: relative;
 font-weight: var(--n-font-weight);
 `), o("select-menu", `
 margin: 4px 0;
 box-shadow: var(--n-menu-box-shadow);
 `, [e({
  originalTransition: "background-color .3s var(--n-bezier), box-shadow .3s var(--n-bezier)"
})])]);
export {
  a as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/select/src/styles/index.cssr.js
// module id = 1693
// module chunks = 41